import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import { api } from "../lib/api";
import { BookOpen, Sparkles, Palette, Library } from "lucide-react";

const FILES = `${process.env.REACT_APP_BACKEND_URL}/api/files/`;

export default function EComics() {
  const [volumes, setVolumes] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/ecomics/volumes").then(r => r.data).catch(() => []),
      api.get("/ecomics/settings/public").then(r => r.data).catch(() => null),
    ]).then(([v, s]) => { setVolumes(v); setSettings(s); setLoading(false); });
  }, []);

  return (
    <PublicLayout>
      <section className="max-w-6xl mx-auto px-6 md:px-10 py-14 md:py-20" data-testid="ecomics-page">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="bb-overline text-[var(--bb-terracotta)] mb-3 flex items-center justify-center gap-2">
            <Palette size={12}/> DIGITAL COMICS
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[var(--bb-forest)] tracking-tight" data-testid="ecomics-title">
            E-COMICS
          </h1>
          <p className="mt-4 text-[var(--bb-muted)] text-base md:text-lg">
            Bala Basava digital comics. Read, listen, explore and colour Bala Basava stories.
          </p>
          {settings?.active && (
            <p className="mt-3 text-sm text-[var(--bb-forest)]/80" data-testid="ecomics-price">
              {settings.product_name} · ₹{settings.price} <span className="text-[var(--bb-muted)]">/ {settings.currency}</span>
            </p>
          )}
          <Link to="/ecomics/library" className="mt-5 bb-btn-secondary inline-flex items-center gap-2 !py-2 text-sm" data-testid="ecomics-mylibrary-link">
            <Library size={14}/> My Library
          </Link>
        </div>

        {loading ? (
          <div className="p-16 text-center text-[var(--bb-muted)]">Loading…</div>
        ) : volumes.length === 0 ? (
          <div className="bb-card p-14 text-center bg-white" data-testid="ecomics-empty">
            <BookOpen size={32} className="mx-auto text-[var(--bb-terracotta)] mb-4"/>
            <div className="font-serif text-2xl text-[var(--bb-forest)]">Volumes coming soon</div>
            <p className="mt-2 text-sm text-[var(--bb-muted)]">New E-Comics volumes are being prepared. Check back shortly.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
            {volumes.map(v => (
              <Link
                key={v.volume_id}
                to={`/ecomics/volume/${v.volume_id}`}
                className="text-left bb-card p-5 bg-white flex flex-col hover:shadow-[0_20px_40px_-20px_rgba(44,53,49,0.25)] transition"
                data-testid={`ecomics-volume-${v.volume_id}`}
              >
                <div className="aspect-[3/4] rounded overflow-hidden bg-[var(--bb-sand)] mb-5 ring-1 ring-[var(--bb-border)]">
                  {v.cover_path ? (
                    <img src={FILES + v.cover_path} alt={v.title} loading="lazy" className="w-full h-full object-cover"/>
                  ) : (
                    <div className="w-full h-full grid place-items-center text-[var(--bb-muted)]"><BookOpen size={36}/></div>
                  )}
                </div>
                <div className="bb-overline text-[var(--bb-muted)] mb-1">VOLUME {v.volume_number}</div>
                <h3 className="font-serif text-xl text-[var(--bb-forest)] leading-snug mb-2">{v.title}</h3>
                <p className="text-sm text-[var(--bb-ink)]/70 leading-relaxed flex-1">{v.description}</p>
                <div className="mt-4 inline-flex items-center gap-1 text-sm text-[var(--bb-terracotta)] font-medium">
                  Read & Listen <Sparkles size={13}/>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
